import type { ReactNode } from 'react';
import { Flex, Text } from '@backstage/ui';

export type LabelValueProps = {
  label: string;
  value: ReactNode;
};

export const LabelValue = ({ label, value }: LabelValueProps) => (
  <Flex direction="column" gap="1">
    <Text variant="body-small" weight="bold">
      {label}
    </Text>
    <Text variant="body-small" color="secondary">
      {value}
    </Text>
  </Flex>
);
